export class EntDirectoryInfoName {
  id: number = 0;
  alias?: string = "";
  nameKy: string = "";
  nameRu: string = "";
}